import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'
import { TIME_FORMAT } from './time.utils'

@Pipe({
  name: 'niceTime'
})
export class NiceTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return this.getNiceTime(value)
    }

    if (args === 'todayTime') {
      const yesterday = moment(value).subtract(1, 'day')
      const daysFromYesterday = moment().diff(yesterday, 'days')
      return daysFromYesterday > 1 ? this.getNiceTime(value) :  moment(value).format(TIME_FORMAT)
    }
  }

  getNiceTime(value) {
    return moment(value).fromNow()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/time/nice-time.pipe.ts